// extracted by mini-css-extract-plugin
export default {"container":"card_container__kAab9","text-container":"card_text-container__hmxme","card-name":"card_card-name__tRoXZ","detail":"card_detail__Cv6Au"};